const domainLearningPath = {
    getLearningPath:   { method: 'get',    url: 'groups/{id}/learning-path' },
    getCourses:        { method: 'get',    url: 'learning-path/courses' },
    getGroupsByCourse: { method: 'get',    url: 'learning-path/courses/{courseId}/groups' },
    getAggregate:      { method: 'get',    url: 'learning-path/aggregate' },
    joinInfo:          { method: 'get',    url: 'groups/{id}/disciplines/{disciplineId}/join-info' },
    addManual:         { method: 'post',   url: 'groups/{id}/manual-completions' },
    historyManual:     { method: 'get',    url: 'groups/{id}/manual-completions/{disciplineId}/history' },
    removeManual:      { method: 'delete', url: 'groups/{id}/manual-completions/{disciplineId}' },
    listOfferIntents:  { method: 'get',    url: 'groups/{id}/offer-intents' },
    addOfferIntent:    { method: 'post',   url: 'groups/{id}/offer-intents' },
    offerWorkTimes:    { method: 'get',    url: 'groups/{id}/offer-intents/work-times' },
    bulkRemoveOfferIntent: { method: 'post', url: 'groups/{id}/offer-intents/bulk-remove' },
    setEnabledOfferIntent: { method: 'post', url: 'groups/{id}/offer-intents/set-enabled' },
    clearOfferIntent:      { method: 'post', url: 'groups/{id}/offer-intents/clear-offer' },
    removeOfferIntent: { method: 'delete', url: 'groups/{id}/offer-intents/{disciplineId}' },
}

export default {
    domainLearningPath,
}
